export default __webpack_public_path__ + "static/shakawah-9ebe35b6b12856c78650b7fb07819ee5.png";